// import Blog Img
import blog1 from "../../assets/img/banner/IMG-20250531-WA0007.jpg"
import blog2 from "../../assets/img/banner/IMG-20250531-WA0007.jpg"
import blog3 from "../../assets/img/banner/IMG-20250531-WA0007.jpg"

// Import Icon
import IconUser from "../../assets/img/icon/user.png"
import IconDate from "../../assets/img/icon/cal.png"






export const NewsAreaData = [
 
  {
    img:blog1,
    heading:`Healthy food and nutrition among
    all the children`,
    category:"#Nutrition",
    para:`Lorem ipsum dolor sit amet, consectetur notted adipisicing elit sed do eiusmod...`,
    IconUser:IconUser,
    IconDate:IconDate
  },

  {
    img:blog2,
    heading:`New era for children learning and
    remove discrimination`,
    category:"#Education",
    para:`Lorem ipsum dolor sit amet, consectetur notted adipisicing elit sed do eiusmod...`,
    IconUser:IconUser,
    IconDate:IconDate
  },
  {
    img:blog3,
    heading:`Ensure pure and mineral drinking
    water for rural people`,
    category:"#Water",
    para:`Lorem ipsum dolor sit amet, consectetur notted adipisicing elit sed do eiusmod...`,
    IconUser:IconUser,
    IconDate:IconDate
  },
  {
    img:blog1,
    heading:`Healthy food and nutrition among
    all the children`,
    category:"#Nutrition",
    para:`Lorem ipsum dolor sit amet, consectetur notted adipisicing elit sed do eiusmod...`,
    IconUser:IconUser,
    IconDate:IconDate
  },

  {
    img:blog2,
    heading:`New era for children learning and
    remove discrimination`,
    category:"#Education",
    para:`Lorem ipsum dolor sit amet, consectetur notted adipisicing elit sed do eiusmod...`,
    IconUser:IconUser,
    IconDate:IconDate
  },
  {
    img:blog3,
    heading:`Ensure pure and mineral drinking
    water for rural people`,
    category:"#Water",
    para:`Lorem ipsum dolor sit amet, consectetur notted adipisicing elit sed do eiusmod...`,
    IconUser:IconUser,
    IconDate:IconDate
  },
]